module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/SweetPotatoCasserole-4866e00a67cfa2d4b06b58d1f2bf4bec.jpg";